import { useMemo } from 'react'
import { FullPageWrapper } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ProviderPageEmailToSmsPageStore } from 'pages/settings/pages/emailToSms/context/emailToSmsContext'
import { EmailToSmsPageStore } from 'pages/settings/pages/emailToSms/store/emailToSmsPageStore'
import { EmailToSmsDropdowns } from 'pages/settings/pages/emailToSms/ui/EmailToSmsDropdowns/emailToSmsDropdowns'
import { EmailToSmsHeader } from 'pages/settings/pages/emailToSms/ui/EmailToSmsHeader/emailToSmsHeader'
import styles from './styles.module.scss'

const EmailToSmsPageContent = () => {
  return (
    <div className={styles.page}>
      <EmailToSmsHeader />
      <EmailToSmsDropdowns />
    </div>
  )
}

export const EmailToSmsPage = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new EmailToSmsPageStore(entities), [])

  return (
    <FullPageWrapper className={styles.wrap}>
      <ProviderPageEmailToSmsPageStore value={store}>
        <EmailToSmsPageContent />
      </ProviderPageEmailToSmsPageStore>
    </FullPageWrapper>
  )
}
